<template>
  <div>
    <el-dialog
      :title="this.text.title"
      :visible.sync="this.dialogStatus"
      width="20%"
      :modal-append-to-body="false"
      :before-close="beforeClose"
      :destroy-on-close="true"
      append-to-body>
      <el-form :model="formData" :rules="rules" ref="codeForm">
        <el-form-item prop="mobile">
          <el-input v-model="formData.mobile" disabled></el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input v-model="formData.code" placeholder="请输入验证码">
            <template slot="append">
              <el-button type="text" class="get-register" @click="verificationCode" :disabled="isGet">{{ this.text.codeText }}</el-button>
            </template>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="handleClose">取消</el-button>
        <el-button size="medium" class="vcodeBtn" type="primary" @click="onSubmit()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
/* eslint-disable */
import { mapState } from 'vuex'
import storage from '@/utils/localstorage'
export default {
  name: "Vertification",
  props: {
    text: {
      type: Object,
      default: () => {
        return {
          title: "验证手机",
          codeText: "获取验证码",
        }
      }
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dialogBillVisible: {
      type: Boolean,
      default: false
    },
    mobile: {
      type:String,
      default: ''
    }
  },
  computed: {
    ...mapState({
      user: (state) => state.userInfo,
    })
  },
  watch: {
    dialogVisible(val) {
      this.dialogStatus = val;
    },
    dialogBillVisible(val) {
      this.dialogStatus = val;
    },
    "mobile": function(val) {
      if(val) {
        this.$set(this.formData , 'mobile', val)
        this.isToAudit = true
      }else {
        this.isToAudit = false
        let user = storage.get('user_info')
        const { mobile } = user
        this.formData.mobile = mobile
      }
    }
  },
  data() {
    return {
      isToAudit: false,
      isGet: false,
      dialogStatus: false,
      formData: {
        mobile: '',
        code: ''
      },
      rules: {
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
        ]
      }
    }
  },
  methods: {
    beforeClose() {
      this.formData.code = ''
      this.$emit('dialogChanged', false)
    },
    handleClose() {
      this.formData.code = ''
      this.$emit('dialogChanged', false)
    },
    //验证
    onSubmit() {
      this.$refs['codeForm'].validate(valid => {
        if (valid) {
          this.formCodeSubmit()
        } else {
          this.$message.error('验证失败，请重新验证')
          return false
        }
      })
      this.formData.code = ''
    },
    // //获取验证码
    // async verificationCode(){
    //   let verCode  = await this.$api.getCode({
    //     mobile: this.formData.mobile
    //   })
    //   this.countDown(60)
    // },

    //发送短信给审核人员
    async verificationCode() {
      if(this.isToAudit) {
        await this.$api.sendCodeToAudit({
          mobile: this.formData.mobile
        })
      }else {
        await this.$api.getCode({
          mobile: this.formData.mobile
        })
      }
      this.countDown(60)
    },
   
    // 倒计时方法
    countDown (time) {
      if (time === 0) {
        this.text.codeText = "获取验证码"
        this.isGet = false
        return
      } else {
        this.text.codeText = '重新发送(' + time + ')'
        this.isGet = true
        time--
      }
      setTimeout(()=> {
        this.countDown(time)
      }, 1000)
    },
    //实际短信验证请求
    async formCodeSubmit() {
      let userInfo = await this.$api.verifyPhone({
        mobile: this.formData.mobile,
        code: this.formData.code
      })
      console.log(userInfo,"userInfo")
      if (userInfo) {
        this.isGet = false
        this.$emit('onSuccess')
      }
    },
  },
  mounted() {
    if(!this.mobile) {
      let user = storage.get('user_info')
      const { mobile } = user
      this.formData.mobile = mobile
    }
  }
}
</script>
<style scoped lang="stylus">
.get-register
  width: 100px
.vcodeBtn
  margin-left: 10px
.el-button.vcodeBtn.el-button--primary.el-button--medium
  margin-left: 10px
</style>